import TabButton from "./TabButton";
import { TabType } from "../ProfileEditModal";

interface Props {
  activeTab: TabType;
  changeActiveTab: (s: TabType) => void;
}

export default function Sidebar({ activeTab, changeActiveTab }: Props) {
  return (
    <div className="cabinet_profileeditmodal-left-sidebar">
      <TabButton
        sider="basic"
        label="Основная информация"
        activeTab={activeTab}
        changeActiveTab={changeActiveTab}
      />
      <TabButton
        sider="identifier"
        label="Идентификатор"
        activeTab={activeTab}
        changeActiveTab={changeActiveTab}
      />
      <TabButton
        sider="showcase"
        label="Витрина"
        activeTab={activeTab}
        changeActiveTab={changeActiveTab}
      />
      <TabButton
        sider="account"
        label="Аккаунт"
        activeTab={activeTab}
        changeActiveTab={changeActiveTab}
      />
      <TabButton
        sider="privacy"
        label="Конфиденциальность"
        activeTab={activeTab}
        changeActiveTab={changeActiveTab}
      />
      <TabButton
        sider="settings"
        label="Настройки"
        activeTab={activeTab}
        changeActiveTab={changeActiveTab}
      />
    </div>
  );
}
